import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { cloneDeep, isEqual } from 'lodash-es';
import { firstValueFrom, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DeleteAddressWarningComponent } from 'src/app/components/delete-address-warning/delete-address-warning.component';
import { ShippingType } from 'src/app/shared-lib/core/settings';
import { PostalAddress, ProvinceModel } from 'src/app/shared-lib/global/models';
import { AppService } from 'src/app/shared/app.service';
import { CartService } from 'src/app/shared/cart.service';
import { ShippingHelper } from 'src/app/shared/helpers/shipping';
import { ShippingService } from 'src/app/shared/services/shipping.service';
import { AlertModalComponent } from '../../../components/alert-modal/alert-modal.component';
import { OutputMessage } from '../../../models/common/output.model';
import { Order } from '../../../models/models';
import { OrderProcessStatus } from '../../../shared-lib/domains/order';
import { PickupPointService } from '../../../shared-lib/domains/pickup-point/pickup-point.service';
import { UserService } from "../../../shared-lib/domains/user";
import { OrderService } from '../../../shared/order.service';
import { ProvinceComponent } from '../province/province.component';



const cpDniRequired = ['35', '38', '51', '52']; // baleares queda fuera '07'

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss', '../../../account/card-style.scss'],
  standalone: false
})
export class AddressComponent implements OnInit, AfterViewInit {
  /******************/
  ShippingHelper = ShippingHelper;

  provinceComponent = ProvinceComponent;
  @Input() addressO: UntypedFormGroup; // (this.address.value) ---> donde tenemos los datos que van a cambiar constantemente
  @Input() selectedAddress: string; // ---> (tipo de addresss)
  @Input() showClearButton = true;
  @Input() orderId = null;
  @Input() thereIsSelectedPoint;
  @Input() writeAddress: boolean;
  @Input() addressesArray: PostalAddress[];
  @Input() defaultAddressIndex: number;
  @Input() onPickUpPointSelection: boolean = false; // ---> si
  @Input() shippingType: ShippingType;
  @Input() editMode: boolean;
  @Input() billingSameAsShipping: boolean = false; // ---> si la dirección de facturación es la misma que la de envío

  textData = {
    title: '',
    icon: '',
    button: ''
  };

  allProvinces: Array<ProvinceModel> = [];
  initialAddress; //----> valor inicial del formulario;
  secondInitialAddress; // IMPORTANTE
  //                       Valor del formulario al seleccionar una dirección de la lista
  //                       (como hay dos niveles posibles de "Cancelar", el de elegir la dirección y el de editar una de las direcciones.
  //                       Esta variable es para poder regresar del segundo nivel de cancelar al primero).

  dniIsRequired = false;
  address: UntypedFormGroup;
  order: Order = null;
  order$: Observable<Order> = null;
  addressAction: 'add' | 'edit' | 'delete' | 'none' = 'none';
  setAsDefault: boolean = false;
  type: string;
  defaultUserAddressIndex: number; // ---> es una copia del índice de la dirección por defecto del usuario

  //
  validationMessages = {
    'street': [
      { type: 'required', message: 'Campo requerido' }
    ],
    'number': [
      { type: 'required', message: 'Campo requerido' }
    ],
    'addressLine1': [
      { type: 'required', message: 'Dirección Requerida' }
    ],
    'recipient': [
      { type: 'required', message: 'Destinatario requerido' },
      { type: 'pattern', message: 'Escribe también tu apellido' }
    ],
    'phone': [
      { type: 'required', message: 'Escribe tu número de teléfono' },
      { type: 'minlength', message: 'Faltan números' },
      { type: 'maxlength', message: 'Demasiados números' },
      { type: 'pattern', message: 'Número de teléfono incorrecto' }
    ],
    'email': [
      { type: "required", message: "Campo obligatorio" },
      { type: "email", message: "Correo inválido" },
      { type: 'pattern', message: 'Correo inválido' }
    ],
    'city': [
      { type: 'required', message: 'Ciudad Requerida' }
    ],
    'province': [
      { type: 'required', message: 'Provincia Requerida' }
    ],
    'dni': [
      { type: 'required', message: 'DNI/NIE/CIF es requerido para esta provincia' },
      { type: 'validateTaxId', message: 'DNI/NIE/CIF es inválido' },
      { type: 'dniRequired', message: 'DNI/NIE/CIF es requerido para esta provincia' },
    ],
    'postalCode': [
      { type: 'required', message: 'Código Postal Requerido' },
      { type: 'minlength', message: 'Código Postal Muy Corto' },
      { type: 'maxlength', message: 'Código Postal Muy Largo' },
      { type: 'pattern', message: 'Código Postal Incorrecto' },
    ],
    'taxId': [
      { type: 'required', message: 'DNI/NIE/CIF requerido' },
      { type: 'validateTaxId', message: 'DNI/NIE/CIF es inválido' },
      { type: 'dniRequired', message: 'DNI/NIE/CIF es inválido' },
    ],
    'pickupPointName': [],
    'pickupPointCode': [],
    'shippingCourier': [],
    'organization': [
      { type: 'required', message: 'Organización requerida' }
    ]

  };

  constructor(
    private http: HttpClient,
    private modalCtrl: ModalController,
    private fb: UntypedFormBuilder,
    private orderService: OrderService,
    public userService: UserService,
    public cartService: CartService,
    protected appS: AppService,
    private shippingService: ShippingService,
    private pickupPointService: PickupPointService,
  ) {

  }

  async ngOnInit() {
    this.address = this.addressForm(this.addressO.value);

    // Cuando se vuelve de tener un punto de recogida seleccionado a una dirección de envío a domicilio,
    // clearPickupPoint limpia el shippingAddress, haciéndolo inválido, de modo que:
    if (this.addressesArray?.length > 0 && this.address.invalid) {
      this.address.patchValue(this.addressesArray[this.defaultAddressIndex]);
    }

    if (this.orderId) {
      this.order$ = this.orderService.get$(this.orderId)
        .pipe(
          tap(async order => {
            this.order = order;
            if (this.orderId && !this.allowChangeAddress) {
              await this.modalCtrl.dismiss();
              const alert = await this.modalCtrl.create({
                component: AlertModalComponent,
                componentProps: {
                  msg: 'Tu pedido ya ha sido empaquetado y preparado para su envío, por lo que no es posible realizar cambios en la dirección.'
                },
                cssClass: 'auto-height'
              });
              await alert.present();
            }
          })
        );
    }
    if (this.selectedAddress == 'shippingAddress' || this.onPickUpPointSelection) {
      this.type = 'shipping';

      if (this.onPickUpPointSelection) {
        if (!this.addressO.value.pickupPointCode) {
          this.address.reset();
          this.address.patchValue({
            recipient: this.userService.userG?.shippingAddresses?.[this.userService.userG?.defaultShippingAddressIndex]?.recipient ?? (!this.userService.userG.isAnonymous ? this.userService.userG?.displayName : ''),
            phone: this.userService.userG?.shippingAddresses?.[this.userService.userG?.defaultShippingAddressIndex]?.phone || this.userService.userG?.phoneNumber,
            email: this.userService.userG?.shippingAddresses?.[this.userService.userG?.defaultShippingAddressIndex]?.email ?? this.userService.userG?.email,
          });
        }
        if (!!this.zoneValidator(this.addressO)?.zoneRestricted && !this.editMode) {
          this.address.controls.postalCode.reset();
        }
        if (this.address.controls.shippingType) {
          // Preguntamos si el tipo de envío actual (ej. Prioritario) está disponible para puntos
          const availableCouriers = await firstValueFrom(this.pickupPointService.availableCouriers$);
          const availability = this.shippingService.checkShippingTypeAvailabilityWithoutAddress(this.shippingType, this.cartService, 500, availableCouriers);

          if (availability.available) {
            this.address.controls.shippingType.setValue(this.shippingType);
          } else {
            // Esto dispara el Validators.required y desactiva el botón Guardar automáticamente.
            this.address.controls.shippingType.setValue(null);
          }
        }
      }

      if (!this.editMode) {
        this.address.setValidators(this.dniValidator);
        this.address.setValidators(this.zoneValidator.bind(this));
      }
      this.defaultUserAddressIndex = cloneDeep(this.userService.userG?.defaultShippingAddressIndex);

      this.textData.title = this.onPickUpPointSelection ? 'Punto de recogida' : 'Datos de envío';
      this.textData.icon = this.onPickUpPointSelection ? '../../../../assets/icon/location_v2.svg' : '../../../../assets/icon/camion.svg';
      this.textData.button = this.onPickUpPointSelection && !this.editMode ? 'Escoger punto de recogida' : 'Guardar';

    } else if (this.selectedAddress === 'billingAddress') {
      this.type = 'billing';

      this.address.get('taxId').setValidators(Validators.required);
      this.address.get('taxId').updateValueAndValidity();

      this.defaultUserAddressIndex = cloneDeep(this.userService.userG?.defaultBillingAddressIndex);

      this.textData.title = 'Datos de facturación';
      this.textData.icon = '../../../../assets/icon/accounting-invoice.svg';
      this.textData.button = 'Guardar';
    }

    if (this.defaultAddressIndex >= this.addressesArray?.length || this.defaultAddressIndex < 0) {

      this.defaultAddressIndex = this.addressesArray?.findIndex((address) => isEqual(address, this.address.value));

    }

    this.address.valueChanges.subscribe(() => {
      const button = document.getElementById('save-button') as HTMLButtonElement;
      if (button) {
        button.disabled = this.address.invalid;
      }
    });
  }

  zoneValidator(formGroup: UntypedFormGroup) {
    const postalCode: string = formGroup.controls['postalCode'].value;
    return ShippingHelper.isRestricted(postalCode, this.userService.userG?.unrestrictedZones)
      ? { zoneRestricted: true }
      : null;
  }

  dniValidator(formGroup: UntypedFormGroup) {
    const postal: string = formGroup.controls['postalCode'].value;
    let cp = null;
    if (postal && postal.length == 5) {
      cp = postal.split('').slice(0, 2).join('');
    }
    //código postal de las provincias a validadr
    // if (  ['07', '35', '38', '51', '52'].includes(cp)) {
    if (cpDniRequired.includes(cp)) {
      return Validators.required(formGroup.get('dni')) ? {
        dniRequired: true,
      } : null;
    }
    return null;
  }

  async ngAfterViewInit() {
    await this.getProvinces();
    if (!!this.address) {// si hay datos....
      this.setProvince();
      this.initialAddress = this.address.value;
      this.secondInitialAddress = cloneDeep(this.address.value);
    } else {
      console.log('AddressComponent con errores');
    }
  }

  async getProvinces() {
    await this.http
      .get<any>('./assets/data/provincias.json')
      .toPromise()
      .then((data: ProvinceModel[]) => {
        this.allProvinces = data;
        return data;
      });
  }

  // esto solo se activa cuando la longitud es 5
  setProvince() {
    setTimeout(() => {
      const postal: string = this.address.controls['postalCode'].value;

      if (postal && postal.length == 5) {
        const pNumber = postal.split('').slice(0, 2).join('');
        this.dniRequired(pNumber);
        const index = this.allProvinces.findIndex((prov: ProvinceModel) => prov.provincia_id === pNumber);
        if (index != -1 && this.allProvinces.length != 0) {

          this.address.patchValue({
            province: this.allProvinces[index].nombre,
            provinceId: pNumber

          });

        }
      }
    }, 100);
  }

  fixDNI() {
    setTimeout(() => {
      if (this.dniIsRequired) {
        var val = (this.address.get('dni').value as string ?? '');
        val = val.toUpperCase();
        val = val.replace(/\s/g, '');
        this.address.get('dni').setValue(val);
      }
    }, 50);
  }

  fixTaxId() {
    setTimeout(() => {
      var val = (this.address.get('taxId').value as string ?? '');
      if (val?.length > 0) {
        val = val.toUpperCase();
        val = val.replace(/\s/g, '');
        this.address.get('taxId').setValue(val);
        this.address.get('taxId').updateValueAndValidity();
        this.address.updateValueAndValidity();
      }
    }, 50);
  }

  dniRequired(cp) {

    this.dniIsRequired = cpDniRequired.includes(cp);

    if (this.dniIsRequired) {
      // Mostramos el DNI
      this.address.get('dni').markAsTouched();
      this.address.get('dni').markAsDirty();
      this.address.get('dni').updateValueAndValidity();
    } else {
      // RESETEAMOS EL DNI
      this.address.get('dni').reset();
      this.address.get('dni').markAsUntouched();
      this.address.get('dni').markAsPristine();
      this.address.get('dni').setErrors(null);
    }
  }

  onSubmit() {
    if (this.orderId && !this.allowChangeAddress) {
      return;
    }
    if (this.address.valid) {
      //addressline1 es la concatenacion de street number y floor
      if (this.onPickUpPointSelection) {
        const { shippingType, ...addressWithoutShippingType } = this.address.value;

        this.modalCtrl.dismiss({
          shippingAddress: addressWithoutShippingType,
          shippingType: shippingType,
          editMode: this.editMode
        });
      }
      else {
        this.address.patchValue({
          addressLine1: `${this.address.get('street').value}, ${this.address.get('number').value}${this.address.get('floor').value ? ', ' + this.address.get('floor').value : ''}`
        });

        if (this.addressesArray?.length == 0) {
          this.addressAction = 'add';
          this.setAsDefault = true;
          this.defaultAddressIndex = 0;
        }

        this.modalCtrl.dismiss({
          [this.selectedAddress]: this.address.value,
          defaultAddressIndex: this.defaultAddressIndex,
          addressAction: this.addressAction,
          setAsDefault: this.setAsDefault
        });
      }
    } else {
      this.writeAddress = true;
      this.address.markAllAsTouched();
      this.addressAction = 'edit';
    }
  }

  cancel() {

    if (['add', 'edit'].includes(this.addressAction)) {

      if (this.addressAction === 'edit') {
        this.address.patchValue(this.secondInitialAddress);
      } else if (this.addressAction === 'add') {
        const addressToPatch = isEqual(this.initialAddress, this.secondInitialAddress) ? this.initialAddress : this.secondInitialAddress;
        this.address.patchValue(addressToPatch);
      }
      this.addressAction = 'none';
      this.writeAddress = false;
      if (this.orderId) {
        this.defaultAddressIndex = this.addressesArray?.findIndex((address) => isEqual(address, this.initialAddress));
      }
    }
    else if (this.addressAction === 'none') {
      this.addressAction = 'none';
      this.writeAddress = false;
      this.address.patchValue(this.initialAddress);
      this.modalCtrl.dismiss();
    }
    else {
      let backAddress;
      if (this.addressesArray?.some((address) => isEqual(address, this.initialAddress)) || this.orderId) {
        backAddress = this.initialAddress;
      } else {
        this.address.reset();
        backAddress = this.address.value;
      }
      this.modalCtrl.dismiss({ [this.selectedAddress]: backAddress, addressAction: 'cancel' });
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }

  addressForm(_address?) {
    const postalVal = [
      !this.onPickUpPointSelection ? Validators.required : null,
      Validators.minLength(5),
      Validators.maxLength(5),
      Validators.pattern(/^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/)
    ];
    let address = this.fb.group({
      recipient: ['', [Validators.required, Validators.pattern(/^.{2,}\ .{2,}/)]],
      street: ['', !this.onPickUpPointSelection ? Validators.required : ''],
      number: ['', !this.onPickUpPointSelection ? Validators.required : ''],
      floor: [''],
      addressLine1: [''],
      addressLine2: [''],
      city: ['', !this.onPickUpPointSelection ? Validators.required : ''],
      province: ['', !this.onPickUpPointSelection ? Validators.required : ''],
      provinceId: [''],
      postalCode: ['', { validators: Validators.compose(postalVal), updateOn: 'change' }],
      country: [''],
      phone: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(9), Validators.pattern(/^[0-9]*$/)]],
      email: ['', [Validators.email, Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,10}$')]],
      organization: ['', this.selectedAddress === 'billingAddress' ? Validators.required : ''],
      pickupPointName: [''],
      pickupPointCode: [''],
      shippingCourier: [''],
      taxId: [''],
      dni: ['', { updateOn: 'change' }],
    });

    if (_address) {
      address.patchValue(_address);
      // Si se está editando un pedido (hay orderId), no se sobreescriben valores del formulario
      // Se quieren tener los datos igual que en el pedido
      if (this.selectedAddress === 'billingAddress' && !this.orderId && !this.userService.userG?.isAnonymous && !this.billingSameAsShipping) {
        address.get('recipient').patchValue(this.userService.userG?.displayName);
        address.get('recipient').clearValidators();
        address.get('recipient').setValidators(Validators.required);
        address.get('recipient').updateValueAndValidity({ onlySelf: true, emitEvent: false });

        if (!!this.userService.userG?.phoneNumber) {
          address.get('phone').patchValue(this.userService.userG?.phoneNumber);
        }
        address.get('email').patchValue(this.userService.userG?.email);
      }

      if (this.onPickUpPointSelection && !this.editMode) {
        address.addControl('shippingType', this.fb.control('', Validators.required));
      }
    }

    return address;
  }

  get allowChangeAddress() {
    return [OrderProcessStatus.PENDING, OrderProcessStatus.PROCESSING].includes(this.order?.processStatus);
  }

  setDefaultAddress(event: MouseEvent, address, index) {
    if (index === this.defaultAddressIndex) {
      return;
    }

    this.address.reset();
    this.address.patchValue(address);
    this.secondInitialAddress = cloneDeep(this.address.value);
    this.defaultAddressIndex = index;
  }

  userAddressAction(event: any) {
    const message = new OutputMessage(event.type, event.value);
    message.invoke(this);
  }

  addNewAddress() {
    this.address.controls.organization.reset();
    if (this.selectedAddress === 'shippingAddress') {
      this.address.controls.recipient.reset();
      this.address.controls.phone.reset();
      this.address.controls.email.reset();
    }
    if (this.selectedAddress === 'billingAddress') {
      this.address.get('recipient').patchValue(this.userService.userG?.displayName);
      this.address.get('phone').patchValue(this.userService.userG?.phoneNumber || this.cartService.order.shippingAddress.phone);
      this.address.get('email').patchValue(this.userService.userG?.email);
    }

    this.address.controls.street.reset();
    this.address.controls.number.reset();
    this.address.controls.floor.reset();
    this.address.controls.addressLine1.reset();
    this.address.controls.addressLine2.reset();
    this.address.controls.postalCode.reset();
    this.address.controls.city.reset();
    this.address.controls.province.reset();
    this.address.controls.provinceId.reset();
    this.address.controls.taxId.reset();
    this.writeAddress = true;
    this.addressAction = 'add';
  }

  onChangeAddress(editData) {

    const { address, index } = editData;
    this.writeAddress = true;
    this.addressAction = 'edit';
    this.defaultAddressIndex = index;
    this.address.patchValue(address);

    setTimeout(() => {
      const button = document.querySelector('button[type="submit"]') as HTMLButtonElement;
      if (button) {
        button.disabled = this.address.invalid;
      }
    });

  }

  async onDeleteAddress(toDeleteData) {

    if (toDeleteData) {

      const { address, type, index } = toDeleteData;

      const modal = await this.modalCtrl.create({
        component: DeleteAddressWarningComponent,
        componentProps: {
          type: type,
          address: address,
        },
        backdropDismiss: false,
        cssClass: 'auto-height default-address-warning-modal'
      });

      modal.onWillDismiss().then(async (resp) => {

        if (resp.data.delete) {

          // Lógica para eliminar la dirección, teniendo en cuenta si type es shipping o billing
          // ...
          this.addressAction = 'delete';

          this.addressesArray.splice(index, 1); // Se elimina la dirección del array
          let updateData = { [`${type}Addresses`]: this.addressesArray as any };

          // Si se han eliminado todas las direcciones
          if (this.addressesArray.length === 0) {
            this.address.reset();
            this.defaultAddressIndex = null;
            this.defaultUserAddressIndex = null;
            updateData = { ...updateData, [`default${type.charAt(0).toUpperCase() + type.slice(1)}AddressIndex`]: null };
          }

          // Si solo queda una dirección, se establece como predeterminada
          else if (this.addressesArray.length === 1) {
            updateData = { ...updateData, [`default${type.charAt(0).toUpperCase() + type.slice(1)}AddressIndex`]: 0 };
            this.defaultAddressIndex = 0;
            this.defaultUserAddressIndex = 0;
          }

          // Si queda más de una dirección
          else if (this.addressesArray.length > 1) {
            // Si el índice de la dirección eliminada es menor o igual al índice de la dirección por defecto en el carrito, y si
            // el índice de la dirección por defecto es mayor que 0, decrementamos el índice de la dirección por defecto
            if (index <= this.defaultAddressIndex && this.defaultAddressIndex > 0) {
              this.defaultAddressIndex--;
            }

            // De forma separada se trata con el índice de la dirección por defecto del usuario (BD)
            // Si el índice de la dirección eliminada es menor o igual al índice de la dirección por defecto del usuario, y si
            // el índice de la dirección por defecto del usuario es mayor que 0, decrementamos el índice de la dirección por defecto.
            if (index <= this.defaultUserAddressIndex && this.defaultUserAddressIndex > 0) {
              updateData = { ...updateData, [`default${type.charAt(0).toUpperCase() + type.slice(1)}AddressIndex`]: --this.defaultUserAddressIndex };
            }
          }

          if (this.orderId) {
            this.defaultAddressIndex = this.addressesArray?.findIndex((address) => isEqual(address, this.initialAddress));
            if (this.addressesArray.length === 0) {
              this.address.patchValue(this.initialAddress);
            }
          }

          // Modificación en BD del usuario
          await this.userService.setUser({ ...this.userService.userG, ...updateData });

          if (this.defaultAddressIndex !== null && this.defaultAddressIndex !== undefined) {
            this.address.patchValue(this.addressesArray[this.defaultAddressIndex]);
          }

          // Modificación de los índices en el servicio del carrito
          if (this.cartService.defaultCartAddressIndexes) {
            this.cartService.defaultCartAddressIndexes[this.type] = this.defaultAddressIndex;
          }
        }
      });

      modal.present();
    }
  }

  defaultAddressIsSelected = () => {
    return this.defaultAddressIndex === this.defaultUserAddressIndex;
  };

  shippingTypeChange(shippingType: any) {
    this.address.get('shippingType').setValue(shippingType);
  }

}

